import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

import { getPatientId } from "~/actions/get_patient_id";
import { isPatient } from "~/common/patient";
import { RemoteLogErrorBoundary } from "~/components/common/remote-log-error-boundary";
import { Layout } from "~/components/ui/layout";
import { Loader } from "~/components/ui/loader";
import { useIntlDocumentTitle } from "~/hooks/use-document-title";
import { useScrollToTop } from "~/hooks/use-scroll-to-top";
import { useAppDispatch, useAppSelector } from "~/store";
import type { NumericString } from "~/types/common";

import { PatientDeliveries } from "./patient_show/patient_deliveries";
import { PatientId } from "./patient_show/patient_id";

export default function PatientDeliveryPage({ bareLayout = false }: { bareLayout?: boolean } = {}) {
  const { patient_id } = useParams<{ patient_id: NumericString }>();

  useIntlDocumentTitle("pat.block.deliveries.deliveries.impressions", patient_id);
  useScrollToTop();

  const dispatch = useAppDispatch();

  const patient = useAppSelector((state) => state.patient);
  const patientIsLoading = !isPatient(patient);

  const deliveries = useAppSelector((state) => state.delivery.deliveries);
  const deliveriesAreLoading = useAppSelector((state) => state.delivery.loading);

  useEffect(() => {
    void dispatch(getPatientId(Number(patient_id), /*fetchDeliveries:*/ true));
  }, [patient_id, dispatch]);

  const body =
    patientIsLoading || deliveriesAreLoading ? (
      <Loader />
    ) : (
      <main className="row">
        <div className="col-md-8">
          <RemoteLogErrorBoundary component="patient_deliveries">
            <PatientDeliveries patient={patient} deliveries={deliveries} />
          </RemoteLogErrorBoundary>
        </div>

        <div className="col-md-4">
          <PatientId patient={patient} />
        </div>
      </main>
    );

  // Under the redesign shell the chrome is already provided (RedesignLegacyCard); skip the legacy Layout.
  return bareLayout ? body : <Layout>{body}</Layout>;
}
